import { Box, Container } from '@mui/material'
import PageHeader from 'components/common/PageHeader/PageHeader';
import { useNavigate } from 'react-router-dom';
import useGlobalStyles from 'styles/globalStyles';
import UpgradePlanButton from 'components/user/UpgradePlanButton/UpgradePlanButton';
import CurrentPlanDetails from 'components/user/CurrentPlanDetails/CurrentPlanDetails';
import { useGetCurrentPlan, useGetNextPlan } from 'hooks/usePlans';
import { useEffect, useMemo } from 'react';
import { dateToString } from 'common/utils';

export default function CurrentPlanPage() {
  const globalStyles = useGlobalStyles();
  const { data: plan, refetch } = useGetCurrentPlan();
  const { data: nextPlan, refetch: refetchNextPlan } = useGetNextPlan();

  const hasNextPlan = useMemo(() => {
    return nextPlan?.data?.next_plan ? true : false;
  }, [nextPlan]);

  useEffect(() => {
    refetch();
  }, [plan])

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Current Plan'}
            description={hasNextPlan ? `Your subscription will switch to (${nextPlan.data.next_plan}) plan on ${dateToString(new Date(nextPlan.data.next_billing_date))}` : ``}
            buttons={[
              <UpgradePlanButton
                key='upgrade-plan'
                refetch={refetch}
              />
            ]}
          />
        </Box>

        <Box mt={3}>
          <CurrentPlanDetails plan={plan} />
        </Box>
      </Container>
    </Box>
  )
}
